import { SidebarSectionType, StepTipType } from 'data/types';

type AccessoriesTipSectionsArgs = {
  textKeys: Record<string, string>;
  ready: boolean;
  hasLineSetSection: boolean;
  hasAccessorySections: boolean;
};

export function getAccessoriesTipSections({
  textKeys,
  ready,
  hasLineSetSection,
  hasAccessorySections
}: AccessoriesTipSectionsArgs): SidebarSectionType[] {
  const getStepText = (
    field: `tip_${number}_title` | `tip_${number}_description`,
    fallback: string
  ) => {
    return textKeys[`step_accessories_${field}`] ?? fallback;
  };

  if (!ready) {
    return [];
  }

  const tips: StepTipType[] = [
    ...(hasLineSetSection
      ? [
          {
            targets: ['line-set-drawer'],
            title: getStepText('tip_1_title', 'Pick line sets and wire'),
            description: getStepText(
              'tip_1_description',
              'Each air handler needs a line set to reach its condenser, plus communication wire. We recommend lengths based on your layout \u2014 adjust them if your runs differ.'
            )
          }
        ]
      : []),
    ...(hasAccessorySections
      ? [
          {
            targets: ['first-accessory-section'],
            title: getStepText('tip_2_title', 'Review each accessory group'),
            description: getStepText(
              'tip_2_description',
              'Each section like this one covers one accessory type with our recommendations marked. Open a section to choose options and set quantities per condenser or air handler.'
            )
          }
        ]
      : []),
    {
      targets: ['include-all-recommended'],
      title: getStepText('tip_3_title', 'Or add everything we recommend'),
      description: getStepText(
        'tip_3_description',
        'Flip this on to add every recommended accessory across all groups at once. You can still fine-tune or remove individual items afterward.'
      )
    }
  ];

  return [
    {
      id: 'accessories',
      title: 'Add Accessories',
      description: '',
      steps: [
        {
          id: 'accessories',
          title: 'Add Accessories',
          description: '',
          status: 'incomplete',
          tips
        }
      ]
    }
  ];
}
